import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { gnbConst } from "../constants/gnbConst";
import {
  CommmonBoxLayout,
  CommonBoxTitle, CommonFooter,
  CommonLayout,
  ContentBox,
  DetailInfoBox,
  FlexColBetweenBox
} from "../style/common";
import { flexBetween } from "../style/mixins";
import DownloadBtns from "../components/material/DownloadBtns";
import ContentBtns from "../components/notice/ContentBtns";
import { useAlertStore } from "../store/alertStore";
import { useNavigatePage } from "../hooks/useNavigatePage";
import { delContents, getContents } from "../api/contents";
import { Spinner } from "../components/common/Spinner";
import { dateHyphen } from "../utils/dateFormChange";
import { isFilePath } from "../utils/isFilePath";
import config from "../config";

export default function MaterialDetail() {
  const { idx } = useParams<{ idx: string }>();
  const pageTitle = gnbConst[3].title;
  const setAlert = useAlertStore((state) => state.setAlert);
  const { onMovementPage } = useNavigatePage();
  const [materialData, setMaterialData] = useState<ContentGetApiResponse>();

  useEffect(() => {
    const getNotice = async () => {
      try {
        const response = await getContents({ idx: idx as string }, "material");
        if (response.statusCode === 200) {
          setMaterialData(response);
        } else {
          alert("공지사항을 불러오는데 실패했습니다.");
          onMovementPage(-1);
        }
      } catch (error) { }
    };

    getNotice();
  }, [idx]);

  const onDelClick = async () => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("복구가 불가능합니다. 정말 삭제하시겠습니까?")) {
      console.log(idx);
      const response = await delContents({ idx: idx as string }, "material");

      if (response.statusCode === 200) {
        setAlert("삭제되었습니다.", "green");
        onMovementPage(-1);
      } else {
        setAlert(response.message[0], "red");
      }
    }
  }

  return (
    <CommonLayout>
      <CommmonBoxLayout>
        <FlexColBetweenBox>
          {materialData ? (
            <>
              <div>
                <CommonBoxTitle>{pageTitle}</CommonBoxTitle>
                <MaterialBtnBox>
                  {materialData.data.files ? (<DownloadBtns files={materialData.data.files} />) : <div></div>}
                  <ContentBtns onClick={onDelClick} />
                </MaterialBtnBox>

                <DetailInfoBox>
                  <div>아이디</div>
                  <div>{materialData.data.member?.member_id ? materialData.data.member.member_id : "-"}</div>
                  <div>이름</div>
                  <div>{materialData.data.member?.member_name ? materialData.data.member.member_name : "-"}</div>
                  <div>날짜</div>
                  <div>{materialData.data.date_update ? dateHyphen(materialData.data.date_update, "YYYY-MM-DD") : "-"}</div>
                </DetailInfoBox>

                <MaterialContentBox>
                  {materialData.data.files && materialData.data.files.length > 0 ? (
                    isFilePath(materialData.data.files, "pdf").length > 0 ? (
                      <iframe
                        src={
                          config.front.url as string
                          + isFilePath(materialData.data.files, "pdf")[0].file_url as string
                        }
                        width="100%"
                        height="100%"
                      />
                    ) : "생성한 PDF 파일이 없습니다."
                  ) : "생성한 PDF 파일이 없습니다."}
                </MaterialContentBox>

              </div>

              <CommonFooter>
                {materialData.data.files ? (<DownloadBtns files={materialData.data.files} />) : <div></div>}
                <ContentBtns onClick={onDelClick} />
              </CommonFooter>
            </>
          ) : <Spinner />}
        </FlexColBetweenBox>
      </CommmonBoxLayout>
    </CommonLayout>
  );
}

const MaterialBtnBox = styled.div`
  ${flexBetween};
  margin-bottom: 1rem;
`;

const MaterialContentBox = styled(ContentBox)`
  height: 700px;
`;